import { render, staticRenderFns } from "./setMealControl.vue?vue&type=template&id=2eeb9d6d&scoped=true&"
import script from "./setMealControl.vue?vue&type=script&lang=js&"
export * from "./setMealControl.vue?vue&type=script&lang=js&"
import style0 from "./setMealControl.vue?vue&type=style&index=0&id=2eeb9d6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeb9d6d",
  null
  
)

export default component.exports